import React from "react";
import {Plus, Trash2} from "lucide-react";

import PlaceholderTemplateEditor from "./PlaceholderTemplateEditor";
import BlocksContainerEditor from "../shared/blocks/BlocksContainerEditor";
import LessonBlocksContainerEditor from "./LessonBlocksContainerEditor";
import EditableField from "../../../../../components/elements/EditableField";
import {LANGUAGES} from "../../../../../utils/constants";

export default function PlaceholderCodeEditor({
                                                  block,
                                                  onChange,
                                                  courseId,
                                              }) {

    const config = block.config || {};

    const placeholders = config.placeholders || [];
    const options = config.options || [];

    const updateConfig = (patch) => {

        onChange({
            config: {
                ...config,
                ...patch,
            },
        });

    };

    const insertPlaceholder = (key) => {

        if (placeholders.some(p => p.key === key))
            return;

        updateConfig({

            placeholders: [

                ...placeholders,

                {
                    key,
                    correctOptionText: "",
                }

            ]

        });

    };

    const updatePlaceholder = (index, patch) => {

        const next = [...placeholders];

        next[index] = {

            ...next[index],
            ...patch,

        };

        updateConfig({
            placeholders: next,
        });

    };

    const removePlaceholder = (index) => {

        updateConfig({

            placeholders: placeholders.filter((_, i) => i !== index),

        });

    };

    const addOption = () => {

        updateConfig({

            options: [

                ...options,

                {
                    id: crypto.randomUUID(),
                    text: "",
                }

            ]

        });

    };

    const updateOption = (index, patch) => {

        const next = [...options];

        next[index] = {

            ...next[index],
            ...patch,

        };

        updateConfig({
            options: next,
        });

    };

    const removeOption = (index) => {

        updateConfig({

            options: options.filter((_, i) => i !== index),

        });

    };

    const template =
        typeof config.template === "string"
            ? config.template
            : "";
    console.log(config.template, typeof config.template);

    return (

        <div className="space-y-6">
            <LessonBlocksContainerEditor
                courseId={courseId}
                value={config.prompt ?? {blocks: []}}
                onChange={(prompt) =>
                    updateConfig({prompt})
                }
            />

            <div>

                <label className="block text-sm font-medium mb-2">
                    زبان
                </label>

                <select
                    className="w-full border rounded-lg p-3 bg-gray-50"
                    value={config.language || "python"}
                    onChange={(e) =>
                        updateConfig({
                            language: e.target.value,
                        })
                    }
                >

                    {
                        LANGUAGES.map((item, key) => (
                            <option key={key}>{item}</option>
                        ))
                    }

                </select>

            </div>

            <label className="flex items-center gap-2">

                <input
                    type="checkbox"
                    checked={config.showCompiler ?? true}
                    onChange={(e) =>
                        updateConfig({
                            showCompiler: e.target.checked,
                        })
                    }
                />

                نمایش دکمه اجرا

            </label>

            <div className="space-y-2">
                <EditableField
                    title="Energy Cost"
                    type="number"
                    value={config.energy ?? 0}
                    onSave={(value) =>
                        updateConfig({
                            energy: Number(value) || 0,
                        })
                    }
                />
            </div>

            <PlaceholderTemplateEditor
                language={config.language}
                value={template}
                onChange={(template) => updateConfig({template})}
                onInsertPlaceholder={insertPlaceholder}
            />

            <div className="space-y-3 ltr text-left">

                <h3 className="font-semibold">
                    Placeholderها
                </h3>

                {

                    placeholders.map((placeholder, index) => (

                        <div
                            key={placeholder.key}
                            className="border rounded-xl p-4 space-y-3"
                        >

                            <div className="flex justify-between">

                                <div className="font-medium">
                                    {placeholder.key}
                                </div>

                                <button
                                    type="button"
                                    className="text-red-600"
                                    onClick={() => removePlaceholder(index)}
                                >
                                    <Trash2 size={16}/>
                                </button>

                            </div>

                            <select
                                className="w-full border rounded-lg p-2"
                                value={placeholder.correctOptionText || ""}
                                onChange={(e) =>
                                    updatePlaceholder(index, {
                                        correctOptionText: e.target.value,
                                    })
                                }
                            >
                                <option value="">
                                    انتخاب پاسخ صحیح
                                </option>

                                {options.map(option => (
                                    <option
                                        key={option.id}
                                        value={option.text}
                                    >
                                        {option.text || "(Empty Option)"}
                                    </option>
                                ))}
                            </select>

                        </div>

                    ))

                }

            </div>

            <div className="space-y-3">

                <div className="flex justify-between">

                    <h3 className="font-semibold">
                        گزینه‌ها
                    </h3>

                    <button
                        type="button"
                        className="px-3 py-2 rounded-lg bg-blue-600 text-white inline-flex items-center gap-2"
                        onClick={addOption}
                    >
                        <Plus size={15}/>
                        افزودن گزینه
                    </button>

                </div>

                {

                    options.map((option, index) => (

                        <div
                            key={option.id}
                            className="border rounded-xl ltr p-4 flex gap-3"
                        >

                            <input
                                className="flex-1 border rounded-lg p-2 center text-left font-mono"
                                placeholder="Option"
                                value={option.text}
                                onChange={(e) =>
                                    updateOption(index, {
                                        text: e.target.value,
                                    })
                                }
                            />

                            <button
                                type="button"
                                className="text-red-600"
                                onClick={() => removeOption(index)}
                            >
                                <Trash2 size={16}/>
                            </button>

                        </div>

                    ))

                }

            </div>

            <BlocksContainerEditor
                title="Explanation"
                courseId={courseId}
                value={config.explanation ?? {blocks: []}}
                onChange={(explanation) =>
                    updateConfig({
                        explanation,
                    })
                }
            />

        </div>

    );

}